// import React from "react";
// import Slider from "react-slick";

// const testimonials = [
//   {
//     id: 1,
//     name: "Mr. Rohit Sharma",
//     role: "Corporate Client - Mumbai",
//     image: "images/author-1.jpg",
//     rating: 5,
//     content:
//       "Aaryan Travels has been our go-to travel partner for all corporate transfers. Their punctuality, clean cars, and professional chauffeurs make every journey hassle-free.",
//   },
//   {
//     id: 2,
//     name: "Ms. Neha Patel",
//     role: "Frequent Flyer - Delhi",
//     image: "images/author-2.jpg",
//     rating: 5,
//     content:
//       "I regularly use Aaryan Travels for airport pickups and drops. The drivers are always on time, polite, and helpful. The service quality is simply excellent!",
//   },
//   {
//     id: 3,
//     name: "Mr. Vikas Mehta",
//     role: "Business Owner - Pune",
//     image: "images/author-3.jpg",
//     rating: 4,
//     content:
//       "We booked Aaryan Travels for an all-India business trip. The entire journey was smooth, with reliable cars and a very cooperative driver. Highly recommended!",
//   },
//   {
//     id: 4,
//     name: "Ms. Simran Kaur",
//     role: "Travel Enthusiast - Chandigarh",
//     image: "images/author-4.jpg",
//     rating: 5,
//     content:
//       "Aaryan Travels made our North India trip unforgettable! The car was comfortable, the driver was knowledgeable, and the entire service was top-notch.",
//   },
// ];

// const Testimonials = () => {

// const settings = {
//   dots: false,
//   infinite: true,
//   speed: 500,
//   autoplay: true,
//   autoplaySpeed: 3000,
//   slidesToShow: 3,
//   slidesToScroll: 1,
//   arrows: false,
//   responsive: [
//     {
//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 2,
//       },
//     },
//     {
//       breakpoint: 768,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         centerMode: false,   
//       },
//     },
//   ],
// };


//   const renderStars = (count) => {
//     let stars = [];
//     for (let i = 1; i <= 5; i++) {
//       stars.push(
//         <i
//           key={i}
//           className={`fa-star pt-4 ${i <= count ? "fa-solid" : "fa-regular"}`}
//         ></i>
//       );
//     }
//     return stars;
//   };

//   return (
//     <div className="our-testimonial">
//       <div className="container">
//         <div className="section-title">
//           <h3 className="pt-5">testimonials</h3>
//           <h2>What our clients say about Aaryan Travels</h2>
        
//         </div>
//         <Slider {...settings}>
//           {testimonials.map((t) => (
//             <div key={t.id} className="testimonial-item">
//               <div className="testimonial-header">
//                 <div className="testimonial-rating">{renderStars(t.rating)}</div>
//                 <div className="testimonial-content">
//                   <p>{t.content}</p>
//                 </div>
//               </div>
//               <div className="testimonial-body">
           
//                 <div className="author-content">
//                   <h3>{t.name}</h3>
//                   <p>{t.role}</p>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </Slider>
//       </div>
//     </div>
//   );
// };

// export default Testimonials;


import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/autoplay";

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Sharma",
    role: "Corporate Client - Mumbai",
    rating: 5,
    content:
      "Aaryan Travels has been our go-to travel partner for all corporate transfers. Their punctuality and professionalism are unmatched.",
  },
  {
    id: 2,
    name: "Ms. Neha Patel",
    role: "Frequent Flyer - Delhi",
    rating: 5,
    content:
      "Always on time for airport pickups and drops. Clean cars and polite drivers.",
  },
  {
    id: 3,
    name: "Mr. Vikas Mehta",
    role: "Business Owner - Pune",
    rating: 4,
    content:
      "Smooth all-India business trip experience. Highly reliable service.",
  },
  {
    id: 4,
    name: "Ms. Simran Kaur",
    role: "Travel Enthusiast - Chandigarh",
    rating: 5,
    content:
      "Comfortable cars, experienced drivers, and great service quality.",
  },
];

const Testimonials = () => {
  const stars = (count) =>
    [...Array(5)].map((_, i) => (
      <i
        key={i}
        className={`fa-star ${i < count ? "fa-solid" : "fa-regular"}`}
      />
    ));

  return (
    <section className="our-testimonial">
      <div className="container">
        <h2 className="text-center mb-4">
          What our clients say about Aaryan Travels
        </h2>

        <Swiper
          modules={[Autoplay]}
          autoplay={{ delay: 3000 }}
          loop={true}
          spaceBetween={20}
          slidesPerView={1}   // ✅ MOBILE DEFAULT
          breakpoints={{
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
        >
          {testimonials.map((t) => (
            <SwiperSlide key={t.id}>
              <div className="testimonial-card">
                <div className="stars">{stars(t.rating)}</div>
                <p>{t.content}</p>
                <h4>{t.name}</h4>
                <span>{t.role}</span>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default Testimonials;
